<div class="ir-plugin th-plugin">
  <div class="ir-line ir-plugin-title">
    <div class="ir-line--right">
      <div class="ir-btn">
        <span></span>
      </div>
      <div class="ir-btn th-btn-normal" [routerLink]="getEditRoute()">
        <span>{{ 'common.edit' | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>{{ 'actionplans.status.name' | translate }}</span>
    </div>
  </div>
  <div class="ir-plugin-content">
    <div class="ir-plugin-values th-plugin-values">
      <p>
        <span
          >{{ 'actionplans.status.name' | translate }} :
          <strong class="ir-ph1">{{ actionPlanItem.status | actionPlanItemStatus }}</strong></span
        >
      </p>
    </div>
  </div>
</div>
